/* ==========================================================================
   LUMÉVIA — JS vanilla (sans dépendance externe)
   ========================================================================== */
(function () {
  "use strict";

  function lumeviaInit() {

  /* ---------- Header sticky : opacité au scroll ---------- */
  var header = document.querySelector("[data-lv-header]");
  if (header) {
    var toggleScrolled = function () {
      if (window.scrollY > 8) {
        header.classList.add("is-scrolled");
      } else {
        header.classList.remove("is-scrolled");
      }
    };
    toggleScrolled();
    window.addEventListener("scroll", toggleScrolled, { passive: true });
  }

  /* ---------- Menu mobile (drawer) ---------- */
  var drawer = document.querySelector("[data-lv-drawer]");
  var openBtn = document.querySelector("[data-lv-drawer-open]");
  var closeBtn = document.querySelector("[data-lv-drawer-close]");
  var overlay = drawer ? drawer.querySelector("[data-lv-drawer-overlay]") : null;

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    document.documentElement.style.overflow = "hidden";
    if (openBtn) openBtn.setAttribute("aria-expanded", "true");
    var firstFocusable = drawer.querySelector("button, a");
    if (firstFocusable) firstFocusable.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    document.documentElement.style.overflow = "";
    if (openBtn) {
      openBtn.setAttribute("aria-expanded", "false");
      openBtn.focus();
    }
  }
  if (openBtn) openBtn.addEventListener("click", openDrawer);
  if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
  if (overlay) overlay.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer && drawer.classList.contains("is-open")) {
      closeDrawer();
    }
  });

  /* ---------- Accordéons génériques (menu mobile + FAQ) ---------- */
  function initAccordionGroup(selector, itemSelector, triggerSelector, panelSelector, allowMultiple) {
    var groups = document.querySelectorAll(selector);
    groups.forEach(function (group) {
      var items = group.querySelectorAll(itemSelector);
      items.forEach(function (item) {
        var trigger = item.querySelector(triggerSelector);
        var panel = item.querySelector(panelSelector);
        if (!trigger || !panel) return;
        trigger.addEventListener("click", function () {
          var isOpen = item.classList.contains("is-open");
          if (!allowMultiple) {
            items.forEach(function (other) {
              if (other !== item) {
                other.classList.remove("is-open");
                var otherTrigger = other.querySelector(triggerSelector);
                if (otherTrigger) otherTrigger.setAttribute("aria-expanded", "false");
              }
            });
          }
          item.classList.toggle("is-open", !isOpen);
          trigger.setAttribute("aria-expanded", String(!isOpen));
        });
      });
    });
  }
  initAccordionGroup("[data-lv-drawer-nav]", ".lv-accordion-item", ".lv-accordion-trigger", ".lv-accordion-panel", true);
  initAccordionGroup("[data-lv-faq]", ".lv-faq-item", ".lv-faq-trigger", ".lv-faq-panel", true);

  /* ---------- Mega menu : accessibilité clavier + comportement fluide ---------- */
  var navItems = document.querySelectorAll("[data-lv-nav-item]");
  var openLinks = [];
  navItems.forEach(function (item) {
    var link = item.querySelector(".lv-nav-link");
    var menu = item.querySelector(".lv-megamenu-v2");
    if (!link || !menu) return;
    var closeTimer = null;

    function openMenu() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      openLinks.forEach(function (l) { if (l !== link) l.setAttribute("aria-expanded", "false"); });
      link.setAttribute("aria-expanded", "true");
    }
    function closeMenuNow() {
      link.setAttribute("aria-expanded", "false");
    }
    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMenuNow, 220);
    }

    link.setAttribute("aria-expanded", "false");
    openLinks.push(link);
    item.addEventListener("mouseenter", openMenu);
    item.addEventListener("mouseleave", scheduleClose);
    link.addEventListener("focus", openMenu);
    link.addEventListener("click", function (e) {
      var isOpen = link.getAttribute("aria-expanded") === "true";
      if (isOpen) {
        e.preventDefault();
        closeMenuNow();
      }
    });
    item.addEventListener("focusout", function (e) {
      if (!item.contains(e.relatedTarget)) {
        closeMenuNow();
      }
    });
    item.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closeMenuNow();
        link.focus();
      }
    });
  });

  document.addEventListener("click", function (e) {
    var insideAnyNavItem = false;
    navItems.forEach(function (item) {
      if (item.contains(e.target)) insideAnyNavItem = true;
    });
    if (!insideAnyNavItem) {
      openLinks.forEach(function (l) { l.setAttribute("aria-expanded", "false"); });
    }
  });

  /* ---------- Tabs de démonstration ---------- */
  var tabGroups = document.querySelectorAll("[data-lv-tabs]");
  tabGroups.forEach(function (group) {
    var tabs = group.querySelectorAll("[data-lv-tab]");
    var panels = group.querySelectorAll("[data-lv-tabpanel]");
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var target = tab.getAttribute("data-lv-tab");
        tabs.forEach(function (t) {
          var active = t === tab;
          t.setAttribute("aria-selected", String(active));
          t.tabIndex = active ? 0 : -1;
        });
        panels.forEach(function (p) {
          p.classList.toggle("is-active", p.getAttribute("data-lv-tabpanel") === target);
        });
      });
      tab.addEventListener("keydown", function (e) {
        var list = Array.prototype.slice.call(tabs);
        var idx = list.indexOf(tab);
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
          e.preventDefault();
          var next = e.key === "ArrowRight" ? (idx + 1) % list.length : (idx - 1 + list.length) % list.length;
          list[next].focus();
          list[next].click();
        }
      });
    });
  });

  } // fin lumeviaInit

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", lumeviaInit);
  } else {
    lumeviaInit();
  }
})();
